module.exports = __webpack_public_path__ + "img/team.d6593a5b.png";